import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation CreateMaintenanceType($companyId: ID!, $attributes: MaintenanceTypeAttributes!) {
    createMaintenanceType(companyId: $companyId, attributes: $attributes) {
       maintenanceType {
        id
        ...CreatedMaintenanceType
      }
      errors {
        path
        message
      }
    }
  }

  fragment CreatedMaintenanceType on MaintenanceType {
    id
    color
    name
  }
`
